import React from 'react';
import styles from './OptionsRow.module.css';

import standard from '../../assets/images/VisualBoards/Markerboards/standard.jpg';
import box from '../../assets/images/VisualBoards/Markerboards/box.jpg';
import maprail from '../../assets/images/VisualBoards/Markerboards/maprail.jpg';
import maprail2 from '../../assets/images/VisualBoards/Markerboards/maprail_2.jpg';
import c4trim from '../../assets/images/VisualBoards/Markerboards/c4_trim.jpg';
import c18trim from '../../assets/images/VisualBoards/Markerboards/c18_trim.jpg';

const OptionsRow = () => {
  return (
    <section
      className={styles.customize_box}
      data-aos="fade-up"
      data-aos-delay="500"
    >
      <div className={styles.customize_options}>
        <h2 className={styles.customize_options_title}>Tray Options</h2>
        <div className={styles.customize_images}>
          <div>
            <img src={standard} alt="standard_tray" />
            <h4>Standard</h4>
          </div>
          <div>
            <img src={box} alt="box_tray" />
            <h4>box</h4>
          </div>
        </div>
      </div>
      <div className={styles.customize_options}>
        <h2 className={styles.customize_options_title}>Map Rail</h2>
        <div className={styles.customize_images}>
          <div>
            <img src={maprail} alt="maprail" />
            <h4>1" Maprail</h4>
          </div>
          <div>
            <img src={maprail2} alt="maprail" />
            <h4>2" Maprail</h4>
          </div>
        </div>
      </div>
      <div className={styles.customize_options}>
        <h2 className={styles.customize_options_title}>Aluminum Trim</h2>
        <div className={styles.customize_images}>
          <div>
            <img src={c4trim} alt="c4_trim" />
            <h4>c4-Aluminum Trim</h4>
          </div>
          <div>
            <img src={c18trim} alt="c18_trim" />
            <h4>c18-Aluminum Trim</h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OptionsRow;
